import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { Add } from '@mui/icons-material';
import ShiftForm from './ShiftForm';
import ViewAllShifts from './ViewAllShifts';

const ShiftManagementTab: React.FC = () => {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [refreshKey, setRefreshKey] = React.useState(0);

  const handleSuccess = () => {
    setDialogOpen(false);
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" fontWeight="bold">
          Shifts
        </Typography>
        <Button variant="contained" startIcon={<Add />} onClick={() => setDialogOpen(true)}  sx={{ textTransform: 'none' }}>
          Add New Shift
        </Button>
      </Box>

      <ViewAllShifts refreshKey={refreshKey} />

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Add New Shift</DialogTitle>
        <DialogContent>
          <ShiftForm showCard={false} showTitle={false} onSuccess={handleSuccess} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} sx={{ textTransform: 'none' }}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ShiftManagementTab;
